import '@hoedokloop/ui/styles.css';
import './app.css';

import { createRoot } from 'react-dom/client';

import { HoedokLoopRoot } from './app-root';
import { sendProductEvent, sendReturnVisit } from './features/analytics/product-events';
import { createWebPlatformAdapters } from './platform/web-adapters';

const adapters = createWebPlatformAdapters();

/**
 * 세션 이전 표준 계측.
 *
 * 왜 필요한가 — 이 제품의 이벤트 카탈로그는 `onboarding_started`부터 시작해서
 * **사용자가 행동하기 전에는 아무것도 발화하지 않았다.** 그래서 첫 방문 계측 요청이
 * 0건이었고 퍼널의 분모가 통째로 비었다(실측 2026-08-12). 전송·검증 경로는 이미 완비돼
 * 있었으므로 새로 배선하지 않고 기존 `sendProductEvent`를 그대로 쓴다.
 * 정본: workspace/docs/munops/ops/release-integrity.md 「표준 계측 이벤트」
 */
function sendStandardEntryEvents(
  analytics: ReturnType<typeof createWebPlatformAdapters>['analytics'],
): void {
  for (const name of ['app_open', 'landing_view'] as const) {
    const key = `hoedokloop:beacon:${name}`;
    let fresh = true;
    try {
      if (sessionStorage.getItem(key)) fresh = false;
      else sessionStorage.setItem(key, '1');
    } catch {
      // private mode 등에서 sessionStorage를 못 쓰면 중복을 감수한다 — 0건보다 낫다.
    }
    if (fresh) sendProductEvent(analytics, name, {});
  }
}

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root element');

createRoot(root).render(
  <HoedokLoopRoot
    adapters={adapters}
    onNormalReady={() => {
      sendStandardEntryEvents(adapters.analytics);
      sendReturnVisit(adapters.analytics);
    }}
  />,
);
